import { useState, useRef } from 'react';
import { useNominatim } from '../../hooks/useNominatim';
import { SearchResults } from './SearchResults';
import type { NominatimResult } from '../../types';

interface SearchBarProps {
  onSelect: (result: NominatimResult) => void;
}

export function SearchBar({ onSelect }: SearchBarProps) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const { results, loading } = useNominatim(open ? query : '');
  const containerRef = useRef<HTMLDivElement>(null);

  const handleSelect = (r: NominatimResult) => {
    setQuery('');
    setOpen(false);
    onSelect(r);
  };

  return (
    <div
      ref={containerRef}
      style={{ position: 'relative', width: '100%', maxWidth: 380 }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          background: '#fff',
          border: '1px solid #e0e0e0',
          borderRadius: 24,
          padding: '6px 14px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <span style={{ marginRight: 8, color: '#9e9e9e', fontSize: 16 }}>🔍</span>
        <input
          type="text"
          placeholder="Search for a city or place…"
          value={query}
          onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(() => setOpen(false), 200)}
          style={{
            border: 'none',
            outline: 'none',
            flex: 1,
            fontSize: 14,
            background: 'transparent',
          }}
        />
        {loading && <span style={{ fontSize: 12, color: '#9e9e9e' }}>…</span>}
      </div>
      {open && <SearchResults results={results} onSelect={handleSelect} />}
    </div>
  );
}
